export default "__VITE_ASSET__XGxfJ2uJ__"